// src/pages/controleBar/comandas/ComandaItensModal.js
import React from "react";
import { formatCurrency } from "../../../utils/numberUtils";
import "./FecharComandaModal.css";
import ModalPortal from '../../../components/modalForm/ModalPortal';

const ComandaItensModal = ({ show, onHide, comanda }) => {
  if (!show || !comanda) return null;

  const itens = comanda.comandaItens || [];
  const total = itens.reduce((sum, item) => sum + (item.valorTotal || 0), 0);

  return (
    <ModalPortal show={show}>
    <div className="modal-overlay" onClick={onHide}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
        style={{ width: "900px" }}
      >
        <h2>Itens da Comanda #{comanda.codigo}</h2>

        <div className="modal-body">
          <table className="modal-tabela">
            <thead>
              <tr>
                <th>Item</th>
                <th>Descricao</th>
                <th>Qtde</th>
                <th>Total</th>
                <th>Pago</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {itens.length > 0 ? (
                itens.map((item) => (
                  <tr key={item.id}>
                    <td style={{ textAlign: "center" }}>{item.item || "-"}</td>
                    <td>{item.produto?.descricao || item.xProd || item.descricao || "-"}</td>
                    <td style={{ textAlign: "center" }}>{item.qtde || item.quantidade || 0}</td>
                    <td style={{ textAlign: "right" }}>{formatCurrency(item.valorTotal || 0)}</td>
                    <td style={{ textAlign: "right" }}>{formatCurrency(item.valorPago || 0)}</td>
                    <td style={{ textAlign: "center" }}>{item.statusDescricao || item.status || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    Nenhum item encontrado para esta comanda.
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr className="tfoot-row">
                <td colSpan={3} style={{ fontWeight: "bold" }}>
                  Total
                </td>
                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                  {formatCurrency(total)}
                </td>
                <td colSpan={2}></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="modal-actions" style={{ justifyContent: "flex-end" }}>
          <button className="btn-cancelar" onClick={onHide}>
            Fechar
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default ComandaItensModal;
